import { inflate, deflate } from 'pako';

export function addElementAtIndex(store, index, element) {
    if (element.row_id == element.uniqueId) {
        store.allRowsData[index] = element;
    } else {
        let isFound = false;
        for (let i=0; i<store.newRows.length; i++) {
            if (store.newRows[i].row_id == element.row_id || store.newRows[i].uniqueId == element.uniqueId) {
                store.newRows[i] = element;
                isFound = true;
                break;
            }
        }
        if (!isFound) {
            store.newRows.push(element);
        }
    }
}

export function notifyDataUpdationFromSocket(message = "", userName = "", rows, columns = [], store, fromWebFormOrEmail = false, fromTriggers = false) {
    if (message.trim() !== "" && (store.listId == window.appStore.containerStore.listId || store.listId == window.appStore.currentVisibleListId)) {
        if (fromWebFormOrEmail && !fromTriggers) {
            window.appStore.notificationStore.showNotification("New row(s) added.", 'info');
        } else if (userName && !fromTriggers) {
            window.appStore.notificationStore.showNotification(message + userName + ".", 'info');
        } else if (!userName && !fromTriggers) {
            window.appStore.notificationStore.showNotification(message + "other user.", 'info');
        }

        if (rows.length > 0) {
            flashCellOnce(store, rows, columns, 5000);
        }
    }
}

export function flashCellOnce(store, rowNodes, columns, duration = 3000) {
    try {
      store.gridApi?.gridOptionsWrapper.setProperty('cellFlashDelay', duration);
      if (columns.length > 0) {
        store.gridApi?.flashCells({ rowNodes: rowNodes, columns: columns });
      } else {
        store.gridApi?.flashCells({ rowNodes: rowNodes });
      }
    } catch (error) {
      console.log('Flashing error', error);
    }
}

export function decompressGzipBase64(base64String) {
    try {
        const binaryString = atob(base64String); // base64 -> binary
        const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
        const decompressed = inflate(byteArray, { to: 'string' }); // gzip -> string
        return decompressed;
    } catch (err) {
        console.error('Decompression failed:', err);
        return null;
    }
}

export function compressToGzipBase64(json) {
    try {
        const compressed = deflate(json);
        const binary = Array.from(compressed).map(byte => String.fromCharCode(byte)).join('');
        return btoa(binary);
    } catch (error) {
        console.error('Compression failed:', error);
        return null;
    }
}

export function normalizeColOptions(colOptions) {
    if (Array.isArray(colOptions)) {
        return colOptions[0] ?? {};
    }

    if (colOptions && typeof colOptions === 'object') {
        return colOptions;
    }

    if (colOptions && typeof colOptions === 'string') {
        try {
            const options = JSON.parse(colOptions);
            return Array.isArray(options) ? options[0] ?? {} : options;
        } catch (e) {
            return {};
        }
    }

    return {};
}